<template>

  <a id="backToTop" href="javascript:scroll(0,0)"><div class="back-to-top"></div></a>

</template>
s
<script>
    export default {
        name: "topButton",
      created() {
        window.onscroll = function () {
          if (document.documentElement.scrollTop + document.body.scrollTop > 900) {
            document.getElementById("backToTop").style.display = "block";
          }
          else {
            document.getElementById("backToTop").style.display = "none";
          }
        }
      },
      mounted() {
        if (document.documentElement.scrollTop + document.body.scrollTop > 900) {
          document.getElementById("backToTop").style.display = "block";
        }
        else {
          document.getElementById("backToTop").style.display = "none";
        }
      }
    }



</script>

<style scoped>
.back-to-top{
  width: 60px;
  height: 60px;
  background-image: url("../../../static/img/topButton/grayButton.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;
  position: fixed;
  right: 12px;
  bottom: 24px;
  opacity: 0.9;
}
@media  screen and  (max-width: 1600px) {
  .back-to-top {
    width: 5.125vw;
    height: 5.125vw;
    right: 0.625vw;
    bottom: 1.25vw;
  }
}
@media screen and (min-width: 1100px) and (max-width: 1600px) {
  .back-to-top {
    width: 3.125vw;
    height: 3.125vw;
    right: 0.625vw;
    bottom: 1.25vw;
  }
}
@media  screen and  (min-width: 1920px) {
  .back-to-top {
    width: 3.125vw;
    height: 3.125vw;
    right: 0.625vw;
    bottom: 1.25vw;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/web/topButton.vue